export type DashboardActionId =
  | "creators-hub"
  | "send-notice"
  | "view-notices"
  | "calendar"
  | "circles"
  | "add-users"
  | "manage-team"
  | "send-image"
  | "attachment"
  | "add-event"
  | "upload-drive"
  | "direct-message";

export type DashboardActionFeatureFlag =
  | "circleManagement"
  | "userManagement"
  | "teamManagement";

type HeroLayoutEntry = {
  id: DashboardActionId;
  variant: "primary" | "secondary";
};

type FeatureGatedLayoutEntry = {
  id: DashboardActionId;
  featureFlag?: DashboardActionFeatureFlag;
};

type DrawerLayoutEntry = FeatureGatedLayoutEntry & {
  section: "create";
};

/** Desktop FeaturedCarousel hero buttons (mobile branch kept for parity). */
export const MOBILE_HERO_LAYOUT: HeroLayoutEntry[] = [
  { id: "creators-hub", variant: "primary" },
  { id: "add-event", variant: "secondary" },
];

export const DESKTOP_HERO_LAYOUT: HeroLayoutEntry[] = [
  { id: "send-notice", variant: "secondary" },
  { id: "creators-hub", variant: "secondary" },
  { id: "upload-drive", variant: "secondary" },
  { id: "direct-message", variant: "secondary" },
];

/** Mobile home 2×2 quick action grid. */
export const MOBILE_HOME_LAYOUT: FeatureGatedLayoutEntry[] = [
  { id: "send-notice" },
  { id: "view-notices" },
  { id: "calendar" },
  { id: "circles", featureFlag: "circleManagement" },
  { id: "add-users", featureFlag: "userManagement" },
  { id: "manage-team", featureFlag: "teamManagement" },
];

/** Mobile FAB drawer create tiles. */
export const MOBILE_DRAWER_LAYOUT: DrawerLayoutEntry[] = [
  { id: "send-notice", section: "create" },
  { id: "send-image", section: "create" },
  { id: "attachment", section: "create" },
  { id: "add-event", section: "create" },
  { id: "upload-drive", section: "create" },
  { id: "direct-message", section: "create" },
];

/** Desktop chart row icon shortcuts. */
export const DESKTOP_CHART_LAYOUT: FeatureGatedLayoutEntry[] = [
  { id: "send-notice" },
  { id: "view-notices" },
  { id: "calendar" },
  { id: "circles", featureFlag: "circleManagement" },
  { id: "add-users", featureFlag: "userManagement" },
];
